import type { JSX } from 'react';
import { List, Text } from '@ksyos/design-system';
import type { IStep, IStepCount } from '@common/interfaces/api/outclinicDashboardApi';
import { OutclinicDashboardFilterButton } from './OutclinicDashboardStepFilterButton';

interface IOutclinicDashboardStepFilterItemProps {
    activeDashboardStepIdentifier: string | null;
    counts: IStepCount[];
    onChange: (stepId: string) => void;
    steps: IStep[];
    title: string;
}

export function OutclinicDashboardStepFilterItem(props: Readonly<IOutclinicDashboardStepFilterItemProps>): JSX.Element {
    return (
        <List.Item sx={{ mb: 6 }}>
            <Text
                color="minimal"
                fontSize="sm"
                fontWeight="medium"
                lineHeight={5}
                mb={4}
            >
                {props.title}
            </Text>
            {props.steps.map((step) => {
                const { overdue, total } = props.counts.find((count) => count.id === step.id) || {
                    overdue: 0,
                    total: 0,
                };

                return (
                    <OutclinicDashboardFilterButton
                        isActive={step.dashboardStepIdentifier === props.activeDashboardStepIdentifier}
                        key={step.id}
                        onClick={() => props.onChange(step.dashboardStepIdentifier)}
                        overdue={overdue}
                        title={step.dashboardName}
                        total={total}
                    />
                );
            })}
        </List.Item>
    );
}
